export default __webpack_public_path__ + "static/media/solteiroduplo_5.04f0bbf1.jpg";